import Skeleton from "@mui/material/Skeleton";
import styles from "./new.module.scss";
import { br, sp } from "../../../../styles/design-tokens";

const sk = (props: any) => <Skeleton animation="wave" variant="rectangular" {...props} />;

function ChatHomeSkeleton(): JSX.Element {
  return (
    <div className={styles.superContainer}>
      <div className={styles.desktopScrollContainer}>
        <div className={styles.contentContainer}>
          <div style={{ display: "flex", alignItems: "center", gap: sp(12) }}>
            {sk({ width: 40, height: 40, sx: { borderRadius: "50%" } })}
            {sk({ width: 200, height: 20, sx: { borderRadius: br(4) } })}
          </div>
        </div>
      </div>
      <div className={styles.inputContainer}>
        <div style={{ display: "flex", gap: sp(8), overflow: "hidden", paddingBottom: sp(12) }}>
          {[132, 104, 108, 96].map((w, i) => (
            <span key={i} style={{ flexShrink: 0 }}>
              {sk({ width: w, height: 40, sx: { borderRadius: br(200) } })}
            </span>
          ))}
        </div>
        {sk({ width: "100%", height: 56, sx: { borderRadius: br(200) } })}
      </div>
    </div>
  );
}

export default ChatHomeSkeleton;
